import { Directive, HostListener, inject } from '@angular/core';
import { FormControl, FormControlDirective, FormControlName, NgModel, NgControl } from '@angular/forms';

/**
 * directive to trim inputs on blur or enter. Usable on input fields within forms.
 */
@Directive( {
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'input[type="text"]:not([hisNoTrim]), input:not([type]):not([hisNoTrim]), textarea:not([hisNoTrim])',
    standalone: false
} )
export class HisTrimInputDirective {
    private ngControl = inject( NgControl, { optional: true, host: true } );

    @HostListener( 'blur', ['$event'] )
    protected trimOnBlur( event: Event ): void {
        if ( event.target instanceof HTMLTextAreaElement ) {
            return this.trim( event.target as HTMLTextAreaElement );
        }

        if ( event.target instanceof HTMLInputElement ) {
            return this.trim( event.target as HTMLInputElement );
        }
    }

    /**
     * event handling for keydown.enter - textareas will be excluded to allow multiline input
     * @param event
     * @returns
     */
    @HostListener( 'keydown.enter', ['$event'] )
    protected trimOnEnter( event: Event ): void {
        if ( !( event.target instanceof HTMLInputElement ) ) {
            return;
        }

        this.trim( event.target as HTMLInputElement );
    }

    private trim( target: HTMLInputElement | HTMLTextAreaElement ): void {
        const trimmed = target.value.trim();
        if ( trimmed !== target.value ) {
            target.value = trimmed;
            this.ngControl?.control?.setValue( trimmed );
        }
    }
}